import moment from 'moment-timezone';

// Since we're comparing two dates that are in the same timezone, the inclusion of the timezone information might seem overkill
// Even though it's rare, a diff in days can be different depending on the timezone. An example of it is the skip of 2011-12-30 in the 'Pacific/Apia' region.
// So I guess, better safe than sorry 🤷
const getCurrentTimezoneDaysDiff = (timeZone: string, date: string) => {
  const currentMoment = moment().tz(timeZone).startOf('day');
  const comparedMoment = moment.tz(date, timeZone).startOf('day');
  return comparedMoment.diff(currentMoment, 'days');
};

export default getCurrentTimezoneDaysDiff;
